import React from 'react';
import LeadScraperShared from '../Shared/LeadScraperShared';
import MainLayout from '../../../components/layout/MainLayout';

const LeadScraper = () => {
  return (
    <MainLayout title="Lead Scraper">
      <div style={{ padding: '24px' }}>
        <LeadScraperShared showSettings={true} />
      </div>
    </MainLayout>
  );
};

export default LeadScraper;
